import { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { assets } from '../assetsConfig';

interface LoginProps {
  onLoginSuccess: (token: string) => void;
}

export default function Login({ onLoginSuccess }: LoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const captchaRef = useRef<ReCAPTCHA>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!captchaToken) {
      setError('Potwierdź reCAPTCHA');
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:8000'}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, captcha_token: captchaToken })
      });
      
      const data = await response.json();

      if (response.ok) {
        onLoginSuccess(data.access_token);
      } else {
        setError(data.detail || 'Błąd logowania');
        captchaRef.current?.reset();
        setCaptchaToken(null);
      }
    } catch (err) {
      setError('Błąd połączenia z serwerem');
      captchaRef.current?.reset();
      setCaptchaToken(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center p-4">
      <div className="bg-white p-10 rounded-[2rem] shadow-2xl shadow-slate-200/50 max-w-sm w-full border border-slate-100">
        <div className="flex justify-center mb-8">
          <img src={assets.img.logo} alt="Logo" className="h-12 w-auto" />
        </div>
        
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <input 
              type="text" 
              placeholder="Login"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:bg-white focus:ring-4 focus:ring-[#c69c6d]/20 focus:border-[#c69c6d] transition-all"
              required
            />
          </div>
          <div>
            <input 
              type="password" 
              placeholder="Hasło"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:bg-white focus:ring-4 focus:ring-[#c69c6d]/20 focus:border-[#c69c6d] transition-all"
              required
            />
          </div>

          <div className="flex justify-center overflow-hidden py-2">
             <ReCAPTCHA
               ref={captchaRef}
               sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || 'test-key'}
               onChange={(token) => setCaptchaToken(token)}
             />
          </div>

          {error && <p className="text-red-500 text-sm text-center font-bold">{error}</p>}
          
          <button 
            type="submit" 
            disabled={isLoading}
            className="w-full py-4 bg-[#125b60] text-white font-bold rounded-xl hover:bg-[#0d4549] transition-all cursor-pointer"
          >
            {isLoading ? 'Ładowanie...' : 'Zaloguj'}
          </button>
        </form>
      </div>
    </div>
  );
}